firebird.controller('webinarAttendeeQuestionSubmitControl', [
    'helperService',
    '$rootScope',
    '$scope',
    '$state',
    '$document',
    '$timeout',
    '$window',
    'notificationService',
    'meetingService',
    'analyticsWrapperService',
    'attendeeService',
    'questionService',
    'socketService',
    'brandingService',
    function (
        helperService,
        $rootScope,
        $scope,
        $state,
        $document,
        $timeout,
        $window,
        notificationService,
        meetingService,
        analyticsWrapperService,
        attendeeService,
        questionService,
        socketService,
        brandingService
    ) {
        var self = this;

        self.initialized = false;
        self.isVisible = isVisible;
        self.showQuestionInput = false;
        self.submittedQuestion = false;
        self.webinarquestion = '';
        self.fadeDuration = '0s';
        self.promptTimeOut = null;

        self.toggleWebinarQuestionPrompt = toggleWebinarQuestionPrompt;
        self.closeQuesAndAnswPrompt = closeQuesAndAnswPrompt;
        self.submitQuestionForWebinar = submitQuestionForWebinar;

        function isVisible() {
            var visible = meetingService.isWebinar() && attendeeService.getIsAttendee();
            return visible;
        }

        function toggleWebinarQuestionPrompt() {
            var self = this;
            self.initialized = true;
            self.fadeDuration = '0.3s';
            self.showQuestionInput = !self.showQuestionInput;
            if (self.promptTimeOut !== null) {
                $timeout.cancel(self.promptTimeOut);
            }
            if (!self.showQuestionInput) {
                self.closeQuesAndAnswPrompt();
            } else {
                if (helperService.isMobile()) {
                    $rootScope.$broadcast('mobile-webinar-attendee-qa-prompt-visible', true);
                }
            }
        }

        function validateQuestionAndAuthor(question) {
            if (!question.question || question.question.trim().length === 0) {
                $window.swal({
                    title: 'Could not submit question',
                    text: 'Question is required',
                    confirmButtonColor: brandingService.getBaseColor(),
                    type: 'warning'
                });
                return false;
            } else if (question.question && question.question.length > 500) {
                $window.swal({
                    title: 'Could not submit question',
                    text: 'Please limit your question to 500 characters',
                    confirmButtonColor: brandingService.getBaseColor(),
                    type: 'warning'
                });
                return false;
            }
            return true;
        }

        function submitQuestionForWebinar() {
            var self = this;

            question = {
                question: self.webinarquestion,
                attendantName: attendeeService.getScreenName()
            };
            if (!validateQuestionAndAuthor(question)) {
                return;
            }

            questionService.addQuestion(question);

            self.submittedQuestion = true;
            self.promptTimeOut = $timeout(function () {
                self.closeQuesAndAnswPrompt();
                self.promptTimeOut = null;
            }, 1500);
            digest();
        }

        function closeQuesAndAnswPrompt() {
            var self = this;
            $timeout(function () {
                self.webinarquestion = '';
                self.submittedQuestion = false;
            }, 100);
            self.showQuestionInput = false;
            if (helperService.isMobile()) {
                $rootScope.$broadcast('mobile-webinar-attendee-qa-prompt-visible', false);
            }
            digest();
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }
    }
]);
